import { useCallback, useRef } from 'react';

/**
 * Guards a side effect against running twice for the same key.
 *
 * Returns a function that answers `true` the first time it sees a key and
 * `false` on every later call with that key, for the lifetime of the component.
 */
export const useOncePerKey = <T>() => {
  const seenKeys = useRef(new Set<T>());

  return useCallback((key: T) => {
    if (seenKeys.current.has(key)) {
      return false;
    }

    seenKeys.current.add(key);

    return true;
  }, []);
};

export default useOncePerKey;
